<div class="error-snackbar">
  <span class="message">{{ message }}</span>
</div>
